module.exports = __webpack_public_path__ + "static/sprite-46ffbf7c16e3ad147caab0a2cef3a9f8.svg";